var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilecomponent = function SvgFilecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 1C7.705 1 1 7.705 1 16s6.705 15 15 15 15-6.705 15-15S24.295 1 16 1Z",
    stroke: "#A08264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.94 13.61a.707.707 0 0 0-.123-.205l-3.75-4.2a.623.623 0 0 0-.183-.137c-.018-.01-.038-.015-.058-.023a.561.561 0 0 0-.162-.036C16.65 9.008 16.638 9 16.625 9H12.25c-.69 0-1.25.628-1.25 1.4v11.2c0 .772.56 1.4 1.25 1.4h7.5c.69 0 1.25-.628 1.25-1.4v-7.7c0-.015-.007-.028-.008-.043a.771.771 0 0 0-.031-.181l-.021-.066Zm-3.69-.41v-1.81l1.616 1.81H17.25Zm-5-2.8H16v3.5c0 .387.28.7.625.7h3.125l.001 7H12.25V10.4Z",
    fill: "#A08264"
  })));
};
export default SvgFilecomponent;